import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=8d9e91ba&scoped=true"
var script = {}
import style0 from "./RouterView.vue?vue&type=style&index=0&id=8d9e91ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9e91ba",
  null
  
)

export default component.exports